export default ({ onClick = undefined }) => (
  <svg
    onClick={onClick}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      fill="#FFCC4D"
    />
    <path
      d="M8.00022 9.33277C6.38999 9.33277 5.32155 9.14521 4.00022 8.88833C3.69844 8.8301 3.11133 8.88833 3.11133 9.77721C3.11133 11.555 5.15355 13.7772 8.00022 13.7772C10.8464 13.7772 12.8891 11.555 12.8891 9.77721C12.8891 8.88833 12.302 8.82966 12.0002 8.88833C10.6789 9.14521 9.61044 9.33277 8.00022 9.33277Z"
      fill="#664500"
    />
    <path
      d="M4 9.77734C4 9.77734 5.33333 10.2218 8 10.2218C10.6667 10.2218 12 9.77734 12 9.77734C12 9.77734 11.1111 11.5551 8 11.5551C4.88889 11.5551 4 9.77734 4 9.77734Z"
      fill="white"
    />
    <path
      d="M5.33377 7.55545C5.94742 7.55545 6.44488 6.859 6.44488 5.99989C6.44488 5.14078 5.94742 4.44434 5.33377 4.44434C4.72012 4.44434 4.22266 5.14078 4.22266 5.99989C4.22266 6.859 4.72012 7.55545 5.33377 7.55545Z"
      fill="#664500"
    />
    <path
      d="M10.6658 7.55545C11.2794 7.55545 11.7769 6.859 11.7769 5.99989C11.7769 5.14078 11.2794 4.44434 10.6658 4.44434C10.0521 4.44434 9.55469 5.14078 9.55469 5.99989C9.55469 6.859 10.0521 7.55545 10.6658 7.55545Z"
      fill="#664500"
    />
  </svg>
);
